import slugify from 'slugify';
import { Story } from '../../schema';
import { InteractionsResponse } from '../../store/backendApi';
import { StoryBox } from './StoryBox';

interface StoryListProps {
  stories: Story[];
  linkSecret: string | null;
  interactions?: InteractionsResponse;
  isOwner: boolean;
  sortOrder: 'ASC' | 'DESC';
  interactionsEnabled: boolean;
}

/**
 * Presentational component for rendering a sorted list of stories.
 * Handles story sorting by date and anchor generation.
 */
export const StoryList = ({
  stories,
  linkSecret,
  interactions,
  isOwner,
  sortOrder,
  interactionsEnabled,
}: StoryListProps) => {
  return (
    <div>
      {stories
        .sort((a, b) => {
          const dateA = new Date(a.date).getTime();
          const dateB = new Date(b.date).getTime();
          // Sort based on trip's sortOrder setting
          return sortOrder === 'ASC' ? dateA - dateB : dateB - dateA;
        })
        .map((story, index) => {
          const anchor = slugify(story.title, {
            lower: true,
            strict: true,
          }).slice(0, 50);
          return (
            <StoryBox
              key={story.id}
              anchor={`${anchor}`}
              story={story}
              linkSecret={linkSecret}
              interactions={interactions}
              isOwner={isOwner}
              index={index}
              interactionsEnabled={interactionsEnabled}
            />
          );
        })}
    </div>
  );
};
